import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import instance from '../../services/services';
import { LIKE_URL } from '../../utils/urls';
import useUserStore from '../../store/userStore';
import PopupLoginError from '../Popup/LoginError';
import { formatLocalString } from '../../utils/validation';
import { useLanguage } from '../../hooks/useLanguage';
import truck from '../../assets/icon/mingcute--truck-line.svg';
import store from '../../assets/icon/mingcute--store-line.svg';

const DefaultProduct = ({ product }) => {
    const { t } = useLanguage();
    const navigate = useNavigate();
    const [isActive, setIsActive] = useState(!!product.goods_like_seq);
    const { memberTokens, userInfo } = useUserStore();
    const [isPopupLoginError, setIsPopupLoginError] = useState(false);

    // 팝업 확인 버튼 클릭 핸들러 (조건부 로직 추가)
    const handleConfirm = () => {
        // isPopupLoginError가 객체이고 action 속성이 'navigate_login'인 경우에만 로그인 페이지로 이동
        if (isPopupLoginError && isPopupLoginError.action === 'navigate_login') {
            navigate('/login');
        }
        // 그 외의 경우는 단순히 팝업만 닫음
        setIsPopupLoginError(false);
    };

    const handleProductDetail = (product) => {
        // group_label_txt가 있으면 팝업 표시
        // if (product.group_label_txt) {
        //     setIsPopupLoginError({
        //         message: "고객센터로 문의바랍니다.",
        //         action: null // 로그인 페이지로 이동하지 않음
        //     });
        //     return;
        // }
        
        // 그렇지 않은 경우만 상세 페이지로 이동
        navigate(`/product/detail/${product.goods_seq}`);
    };

    const handleWishBtnClick = async (e) => {
        e.stopPropagation(); // 상위 요소로의 이벤트 전파 방지
        
        // 로그인 확인
        if (!memberTokens) {
            setIsPopupLoginError({
                message: t('login_required'),
                action: 'navigate_login'
            });
            return;
        }

        try {
            // LIKE_URL에 POST 요청 보내기
            const response = await instance.post(LIKE_URL, {
                goods_seq: product.goods_seq,
                member_seq: userInfo.member_seq
            });
            
            // 응답이 성공적인 경우
            if (response.data.code === 200) {
                setIsActive(!isActive); // 토글 기능 추가
            } else {
                console.error('좋아요 상태 변경 실패:', response.data);
            }
        } catch (error) {
            console.error('좋아요 API 호출 중 오류 발생:', error);
        }
    };

    return (
        <div 
            className="default_prod prod_item"
            onClick={e => {
                // 팝업이 떠 있으면 상세 이동 금지
                if (isPopupLoginError) return;
                // 하트 버튼 클릭 시 상세 이동 금지
                if (
                    e.target.classList.contains('wish_btn') ||
                    e.target.closest('.wish_box')
                ) {
                    return;
                }
                handleProductDetail(product);
            }}
        >
            <div className="border-text-box">{product?.goods_code}</div>

            <div className="prod_img" style={{maxWidth: '100%'}}>
                <div className="wish_box">
                    <button
                        type="button"
                        className={`wish_btn ${isActive ? 'active' : ''}`}
                        onClick={handleWishBtnClick}
                    />
                    {product?.order_visit_flag === 'Y' && (
                        <div >
                            <img src={store} alt="store" />
                        </div>
                    )}
                    {product?.order_parcel_flag === 'Y' && (
                        <div>
                            <img src={truck} alt="truck" />
                        </div>
                    )}
                </div>
                <div className="brand_img">
                    <img src={product?.brand_goods_img} alt="red" />
                </div>
                <div className='product_img'>
                    <img src={product.goods_image[1]} alt="cannon_c500" loading="lazy"/>
                </div>
                {product.summary_flag === 'Y' && (
                    <p className={`${product.summary_color} special_phrase`} 
                        style={{
                            ...(product?.summary_bg_color && { backgroundColor: product.summary_bg_color }),
                            ...(product?.summary_txt_color && { color: product.summary_txt_color }),
                            ...(product?.summary_border_color && { border: `1px solid ${product.summary_border_color}` })
                        }}>
                        {/* 특별문구 */}
                        <span>
                            {product?.summary_txt}
                        </span>
                    </p>
                )}
                {/* 뱃지 */}
                <p className="prod_type">
                    {product?.badgeList?.map((badge, idx) => (
                        <span 
                            key={idx} 
                            className="badge_item"
                            style={{
                                backgroundColor: badge.badge_color_bg,
                                color: badge.badge_color_txt,
                                border: `1px solid ${badge.badge_color_border}`
                            }}
                        >
                            {badge.badge_name}
                        </span>
                    ))}
                </p>
            </div>
            <div className="prod_info">
                {/* <p className="prod_type" style={{  flexWrap: 'wrap'}}>
                    {product?.badgeList?.map((badge, idx) => (
                        <img key={idx} className={`badge_${badge}`} src={badge} alt={badge} loading="lazy"/>
                    ))}
                </p> */}
                <div className="prod_title">
                    <p className="title ellipsis_clamp">
                        {product?.goods_name}
                    </p>
                    <p className="sub_title ellipsis1">{product?.description_kr_01}</p>
                </div>


                {product.goods_type === 'rental' ? (
                    <div className="prod_price" style={{ position: 'relative'}}>
                        {Number(product?.discount_rate) > 0 && (
                            <div className="border-prod_price">{product?.discount_rate}<span style={{fontSize:'11px'}}>%</span></div>
                        )}
                        
                        {product?.group_label_txt ? (
                            <div className="group_label">{product?.group_label_txt}</div>
                        ) : (
                            <>
                                <div className="day half">
                                    <div className="day_hour_price">
                                        <span className="hour">12h</span>
                                        <span className="price">
                                            <span className="price_won">₩</span>
                                            {product?.discount_rate === "0" ? formatLocalString(product?.rental_12_price) : formatLocalString(product?.result_12_price)}
                                        </span>
                                    </div>
                                    {product?.discount_rate  > 0 && (
                                        <div className="consumer_price">
                                            <span className="consumer_price_won">₩</span>
                                            <span className="line_through">{formatLocalString(product?.rental_12_price)}</span>
                                        </div>
                                    )}
                                </div>
                                <div className="day">
                                    <div className="day_hour_price">
                                        <span className="hour">24h</span>
                                        <span className="price">
                                            <span className="price_won">₩</span>
                                            {product?.discount_rate === "0" ? formatLocalString(product?.rental_24_price) : formatLocalString(product?.result_24_price)}
                                        </span>
                                    </div>
                                    {product?.discount_rate > 0 && (
                                        <div className="consumer_price">
                                            <span className="consumer_price_won">₩</span>
                                            <span className="line_through">{formatLocalString(product?.rental_24_price)}</span>
                                        </div>
                                    )}
                                </div>
                            </>
                        )}
                    </div>
                ) : product.goods_type === 'sale' ? (
                    <div className="prod_price sale" style={{ position: 'relative' }}>
                        {Number(product?.discount_rate) > 0 && (
                            <div className="border-prod_price">{product?.discount_rate}<span style={{fontSize:'11px'}}>%</span></div>
                        )}
                        {product.group_label_txt ? (
                            <div className="group_label">{product?.group_label_txt}</div>
                        ) : (
                        <>
                            <div className="day half">
                                <div className="day_hour_price">
                                    <span className="price">
                                        <span className="price_won">₩</span>
                                        {product?.discount_rate === "0" ? formatLocalString(product?.unit_price) : formatLocalString(product?.price)}
                                    </span>
                                </div>
                                {product?.discount_rate > 0 && (
                                <div className="consumer_price">
                                    <span className="consumer_price_won">₩</span>
                                    <span className="line_through">{formatLocalString(product?.unit_price)}</span>
                                </div>
                                )}
                            </div>
                        </>
                        )}
                    </div>
                ) : product.goods_type === 'package' ? (
                    <div className="prod_price" style={{ position: 'relative'}}>
                        {Number(product?.discount_rate) > 0 && (
                            <div className="border-prod_price">{product?.discount_rate}<span style={{fontSize:'11px'}}>%</span></div>
                        )}
                        {product.group_label_txt ? (
                            <div className="group_label">{product?.group_label_txt}</div>
                        ) : (
                        <>
                            <div className="day half">
                                <div className="day_hour_price">
                                    <span className="hour">12h</span>
                                    <span className="price">
                                        <span className="price_won">₩</span>
                                        {product?.discount_rate === "0" ? formatLocalString(product?.result_12_price) : formatLocalString(product?.result_12_price)}
                                    </span>
                                </div>
                                {product?.discount_rate > 0 && (
                                    <div className="consumer_price">
                                        <span className="consumer_price_won">₩</span>
                                        <span className="line_through">{formatLocalString(product?.basic_12_price)}</span>
                                    </div>
                                )}
                            </div>
                            <div className="day">
                                <div className="day_hour_price">
                                    <span className="hour">24h</span>
                                    <span className="price">
                                        <span className="price_won">₩</span>
                                        {product?.discount_rate === "0" ? formatLocalString(product?.result_24_price) : formatLocalString(product?.result_24_price)}
                                    </span>
                                </div>
                                {product?.discount_rate > 0 && (
                                    <div className="consumer_price">
                                        <span className="consumer_price_won">₩</span>
                                        <span className="line_through">{formatLocalString(product?.basic_24_price)}</span>
                                    </div>
                                )}
                            </div>
                        </>
                    )}
                    </div>
                ) : null}
                

            </div>
            <PopupLoginError 
                isPopup={isPopupLoginError} 
                setIsPopup={setIsPopupLoginError}
                onConfirm={handleConfirm}
            />
        </div>
    );
};

export default DefaultProduct;